import { Button } from '@eventbrite/eds-button';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import { getCanonicalSearchUrl } from '@eventbrite/redux-destination';
import { $FixMe } from '@eventbrite/ts-utils';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';
import React from 'react';
import {
    FOLLOWED_PROFILES,
    LIKED_EVENTS,
} from '../../../../../../../constants/constants';
import {
    FOR_YOU,
    ONLINE_TAB,
    SEASONAL_TAB,
} from '../../../../../../../constants/tabConfig';
import {
    BaseSeasonalContentShape,
    EventSearch,
} from '../../../../../../../types/index';
import { HomeEngagementExperimentTrackingLocations } from '../../../../../constants/analytics';
import { logToStatsigHomeEngagement } from '../../../../../utils/analytics';

interface SeeMoreOfBucketProps {
    bucketKey?: string;
    seeMore?: { url?: string };
    onSeeMore: Function;
    searchCriteria?: EventSearch;
    shouldShowSeeMore?: boolean;
    locationSlug?: string;
    tabKey?: string;
    userId?: string;
    seasonalContent: BaseSeasonalContentShape[];
    cityBrowseLink?: boolean;
    customSeeMoreText?: string | GenericLazyString;
}

const SeeMoreOfBucket = (props: SeeMoreOfBucketProps) => {
    const {
        bucketKey,
        seeMore,
        onSeeMore,
        searchCriteria,
        shouldShowSeeMore,
        locationSlug,
        tabKey,
        userId,
        seasonalContent,
        cityBrowseLink,
        customSeeMoreText,
    } = props;

    let seeMoreUrl = seeMore;

    if (shouldShowSeeMore) {
        if (isEmpty(seeMore) && searchCriteria && !isEmpty(locationSlug)) {
            let q = '';

            if (tabKey === SEASONAL_TAB) {
                q = get(
                    seasonalContent,
                    'byDate.eventSearchQ',
                    get(seasonalContent, 'byDate.tabName', ''),
                );
                if (!isString(q)) {
                    q = (q as $FixMe).toString();
                }
            }

            const { price, tags, dates } = searchCriteria;

            seeMoreUrl = {
                url: getCanonicalSearchUrl({
                    slug: locationSlug,
                    price,
                    tags,
                    dates,
                    q,
                }),
            };
        }

        if (bucketKey === LIKED_EVENTS && tabKey === FOR_YOU) {
            seeMoreUrl = {
                url: `/u/${userId}/favorites/events`,
            };
        }

        if (bucketKey === FOLLOWED_PROFILES && tabKey === FOR_YOU) {
            seeMoreUrl = {
                url: `/u/${userId}/following`,
            };
        }

        if (tabKey === ONLINE_TAB) {
            seeMoreUrl = {
                url: '/d/online/all-events/',
            };
        }

        if (cityBrowseLink) {
            seeMoreUrl = {
                url: `/d/${locationSlug}/events/`,
            };
        }
    }

    const handleButtonClick = (url: string, bucketKey: string) => {
        if (cityBrowseLink) {
            logToStatsigHomeEngagement(
                HomeEngagementExperimentTrackingLocations.CITY_CTA,
                !!userId,
            );
        }

        onSeeMore?.(url, bucketKey);
    };

    return (
        <div data-testid="see-more-events">
            {seeMoreUrl?.url ? (
                <div className="eds-align--center eds-l-mar-top-2">
                    <Button
                        type="link"
                        style="neutral"
                        href={seeMoreUrl?.url}
                        onClick={handleButtonClick.bind(
                            null,
                            seeMoreUrl?.url,
                            bucketKey || '',
                        )}
                    >
                        {customSeeMoreText
                            ? customSeeMoreText
                            : gettext('View more')}
                    </Button>
                </div>
            ) : null}
        </div>
    );
};

export default SeeMoreOfBucket;
